export function ReportsToolbar() {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ລາຍງານ</h2>
        <p className="text-muted-foreground text-sm">
          ດູລາຍງານທີ່ຜູ້ໃຊ້ສົ່ງເຂົ້າມາ ແລະ ດຳເນີນການກວດກາ
        </p>
      </div>
    </div>
  );
}
